<div class="sectionb">

            <nav
                class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
                <span class="navbar-brand mb-0 h1"><i class="far fa-folder"></i> Site Files</span>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div class="ml-auto d-flex justify-content-end">
                        <ul class="nav navbar-nav ml-auto">
                            <li class="nav-item">
                                <a class="nav-link" *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}" (click)="openDialogAddFilesTo()" matTooltip="Add files to site">
                                    <i class="fa-plus-square far"></i> Add Files</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" role="button" (click)="refresh();false">
                                    <i class="fas fa-sync"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
      
            <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
            <perfect-scrollbar style="max-height: 550px;">
            <table mat-table #table [dataSource]="dataSource" matSort
                class="table table-hover table-striped frms-table table-align-middle">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Name </th>
                    <td mat-cell *matCellDef="let row">
                        <app-uifile [filedata]="row"></app-uifile>
                        {{row.name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="filetype">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.type}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="filesize">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Size </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.filesize | filesize}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="creation_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.creation_date | date:'dd-MM-yyyy HH:mm:sss'}}
                    </td>
                </ng-container>                
<!--                 <ng-container matColumnDef="modifydate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}
                    </td>
                </ng-container> -->
                <!-- Symbol Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                        <div class="td-actions text-right">
                            <button type="button" class="btn btn-sm btn-outline-secondary" [matMenuTriggerFor]="menu">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="">
                                <div mat-menu-item *permusr="{id:controlEnum.BTN_SITE_EDIT, authFunction:acl_btn_bysite(controlEnum.BTN_SITE_EDIT,site)}">
                                    <a class="dropdown-item text-danger" [routerLink]=""
                                        (click)="openDialogDeleteFile(row)">
                                        <i class="far fa-trash-alt"></i> Delete
                                    </a>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" class="thead-dark"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" ></tr>
            </table>
            </perfect-scrollbar>
            <mat-paginator [pageSizeOptions]="[20,50,100,200]" showFirstLastButtons></mat-paginator>
    

</div>